import React from 'react';
import TopBar from '../../Components/TopBar';
import Page from '../../Components/Containers/Page';

const Invoices = () => {

    return <>
        <TopBar title="Invoices" />
        <Page>
            <p>Hello</p>
        </Page>
    </>
}

export default Invoices;